document.addEventListener("DOMContentLoaded", function () {
    // 1. .main-sec02 .m-mixed-layout__wrapper에 .swiper .mSwiperCard 클래스 추가
    document.querySelectorAll('.main-sec02 .m-mixed-layout__wrapper').forEach(wrapper => {
        wrapper.classList.add('swiper', 'mSwiperCard');
    });

    // 2. .main-sec02 .m-mixed-layout__wrapper .m-mixed-layout__inner에 .swiper-wrapper 클래스 추가
    document.querySelectorAll('.main-sec02 .m-mixed-layout__wrapper .m-mixed-layout__inner').forEach(inner => {
        inner.classList.add('swiper-wrapper');
    });

    // 3. .main-sec02 .m-mixed-layout__wrapper .m-mixed-layout__inner .m:column 에 .swiper-slide 클래스 추가
    document.querySelectorAll('.main-sec02 .m-mixed-layout__wrapper .m-mixed-layout__inner .m\\:column').forEach(slide => {
        slide.classList.add('swiper-slide');
    });

    if (window.innerWidth >= 1025) {
      var mSwiperCard = new Swiper(".mSwiperCard", {
        slidesPerView : 3.2,
        spaceBetween: 20,
        autoHeight: false,
        freeMode : true,
        slidesOffsetAfter: 66,
        breakpoints: {
          1600: {
            slidesPerView: 3.2,
            spaceBetween: 20
          },
          1450: {
            slidesPerView: 2.8,
            spaceBetween: 20
          },
          1350: {
            slidesPerView: 2.5,
            spaceBetween: 20
          },
          1200: {
            slidesPerView: 2.3,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 2.2,
            spaceBetween: 20
          },
        }
      });
    }
  
    if (window.innerWidth <= 1024) {
      var mSwiperCard = new Swiper(".mSwiperCard", {
        slidesPerView : 1.5,
        spaceBetween: 10,
        autoHeight: false,
        freeMode : true,
        slidesOffsetAfter: 36,
      });
    }
});
